//Login.jsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import { setUserName } from "../store/authSlice";
import { setFoods } from "../store/foodsSlice";
import { setMeals } from "../store/mealsSlice";
import { setPersonalAll } from "../store/personalSlice";
import { setToday, clearToday } from "../store/todaySlice";
import { loginUser } from "../api";
import indexedDbStorage from "../store/indexedDbStorage.js"; 

import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text
} from "../components/layout";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userName = useSelector((state) => state.auth.userName);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [auth, setAuth] = useState(false);

  // Check token on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedName = localStorage.getItem("userName");

    if (token) setAuth(true);
    if (storedName) dispatch(setUserName(storedName));
  }, [dispatch]);

const handleLogin = async () => {
    try {
      const data = await loginUser({ name, email, password });
      
      if (data?.token) {

        localStorage.setItem("token", data.token);
        localStorage.setItem("userName", data.userName);

        // ✨ FIX: Define todayStr here
        const todayStr = new Date().toISOString().split('T')[0];
        
        // 🌐 2. Fetch cloud data using your defined todayStr
        // Note: Ensure your BASE_URL is handled correctly here
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/sync?date=${todayStr}`, {
          headers: { 'Authorization': `Bearer ${data.token}` }
        });
        
        const { snapshot, actualDate } = await res.json();

        console.log(snapshot);

        if (snapshot) {
          // 🧠 3. Update Redux RAM with Backend data
          if (snapshot.foods) dispatch(setFoods(snapshot.foods));
          if (snapshot.meals) dispatch(setMeals(snapshot.meals));
          // if (snapshot.profile) dispatch(setPersonalAll(snapshot.profile));
          if (snapshot.profile) dispatch(setPersonalAll({
            profile: snapshot.profile,
            byDate: actualDate === todayStr ? (snapshot.byDate || {}) : {},
          }));

          // if (snapshot.entries) dispatch(setToday(snapshot.entries));

          if (actualDate === todayStr && snapshot.entries) {
            dispatch(setToday(snapshot.entries));
          } else {
            dispatch(clearToday()); 
          }

        }
        
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/register");
      }
    } catch (err) {
      console.error("Login sync failed:", err);
      navigate("/register");
    }
  };

  if (auth && userName) {
    // return (

  
    //   // <Box sx={{ mt: 10, textAlign: "center" }}>
    //   //   <Typography variant="h5">
    //   //     Welcome back, {userName}!
    //   //   </Typography>

    //   //   {/* <Button
    //   //     sx={{ mt: 2 }}
    //   //     variant="contained"
    //   //     onClick={() => navigate("/dashboard")}
    //   //   >
    //   //     Go to Dashboard
    //   //   </Button> */}
    //   // </Box>
    // );
  }

  return (

    <Screen>
      <Content>
        <Card style={{
          padding: space.sm,
          gap: space.lg
        }}
        >
          <Text variant="h3"> Login</Text>

          <TextInput
            placeholder="Name"

            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{
              background: colors.surfaceSoft,
              borderBottom: borders.sm,
              borderColor: colors.primary
            }}
          />
          <TextInput
            placeholder="Email"
   
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              background: colors.surfaceSoft,
              borderBottom: borders.sm,
              borderColor: colors.primary
            }}
          />
          <TextInput
            placeholder="Password"

            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              background: colors.surfaceSoft,
              borderBottom: borders.sm,
              borderColor: colors.primary
            }}
          />
          <Button
            onClick={handleLogin}
          >
          Login
          </Button>
        </Card>
      </Content>
    </Screen>
  );
};

export default Login;